<template>
    <v-container fluid>
        <v-card>
            <v-card-title>
                <v-row align="center">
                    <v-col cols="12" lg="4">
                        Players
                    </v-col>
                    <v-col cols="12">
                        <player-filters @setFilters="setFilters"/>
                    </v-col>
                    <v-col cols="12" align="end">
                        <v-btn class="my-2 mr-2" dark small color="black" @click="downloadPlayersCSV">
                            <v-icon dark>mdi-download</v-icon>Export CSV
                        </v-btn>
                        <v-btn class="my-2 mr-2" dark small color="black" @click="showImportDialog = true">
                            <v-icon dark>mdi-upload</v-icon>Upload CSV
                        </v-btn>
                        <v-btn class="my-2 mr-2" dark small color="black" @click="createPlayer">
                            <v-icon dark>mdi-plus</v-icon>Create
                        </v-btn>
                        <v-btn class="my-2 mr-2" dark small color="black" @click="resetDoctorChecks">
                            <v-icon dark>mdi-medical-bag</v-icon>Reset Doctor Checks
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
        </v-card>
        <import-dialog
            :open-dialog="showImportDialog"
            entity-label="Players CSV"
            :successfull-import="successfullImport"
            :message="message"
            file-type=".csv,text/csv"
            @file-import="uploadPlayers"
            @close-import-dialog="closeImportDialog"
        />
        <array-view
            :items="players"
            :headers="displayInfo"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            @handleClick="handleClick"
            @paginationChange="paginationChange"
            @onDelete="onDelete"
            @sortingChange="sortingChange"
        />
    </v-container>
</template>

<script>
    import playerService from '@/services/player'
    import ArrayView from '@/components/ArrayView'
    import PlayerFilters from '@/components/PlayerFilters'
    import ImportDialog from '@/components/ImportDialog'

    export default {
        name: 'Player',
        components: { ArrayView, PlayerFilters, ImportDialog },
        data: () => {
            return {
                successfullImport: null,
                players: [],
                displayInfo: [
                    {
                        text: 'Id',
                        value: 'id'
                    },
                    {
                        text: 'Active',
                        value: 'active'
                    },
                    {
                        text: 'Name',
                        value: 'name'
                    },
                    {
                        text: 'Doctor Check',
                        value: 'doctorCheck'
                    },
                    {
                        text: '#MatchesRule',
                        value: 'noOfMatches'
                    },
                    {
                        text: 'Jersey',
                        value: 'jersey'
                    },
                    {
                        text: 'Position',
                        value: 'position'
                    },
                    {
                        text: 'Team',
                        value: 'team',
                        subLevel: 'name'
                    }
                ],
                showImportDialog: false,
                size: 100,
                totalPages: 0,
                page: 1,
                loading: false,
                filters: null,
                message: null,
                sortingOptions: {
                    sortBy: null,
                    sortDesc: null
                }
            }
        },
        watch: {
            filters: {
                handler() {
                    this.fetchFilteredPlayers()
                }
            }
        },
        created() {
            this.filters = this.$store.getters.getPlayerFilters
            this.page = this.$store.getters.getPage
            this.fetchFilteredPlayers()
        },
        methods: {
            sortingChange(options) {
                this.sortingOptions.sortBy = options.sortBy[0]
                this.sortingOptions.sortDesc = options.sortDesc[0] ? 'DESC' : 'ASC'
                this.fetchFilteredPlayers()
            },
            downloadPlayersCSV() {
                playerService.downloadPlayersCSV(this.filters).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'players.csv')
                    document.body.appendChild(link)
                    link.click()
                })
            },
            closeImportDialog() {
                this.showImportDialog = false
                // reset state so dialog shows proper buttons next time
                this.successfullImport = null
            },
            uploadPlayers(file) {
                this.successfullImport = null
                const formData = new FormData()
                formData.append('file', file)
                playerService.uploadPlayersCSV(formData).then(() => {
                    this.successfullImport = true
                    this.fetchFilteredPlayers()
                    this.closeImportDialog()
                }).catch((error) => {
                    this.successfullImport = false
                    this.message = error.response.data.message || 'Import failed'
                })
            },
            paginationChange(page, size) {
                this.size = size
                this.page = page
                this.$store.dispatch('setPage', page)
                this.fetchFilteredPlayers()
            },
            handleClick(action, item) {
                this.$router.push(`/players/${item.id}/${action}`)
            },
            createPlayer() {
                this.$router.push(`/players/create`)
            },
            onDelete(item, page) {
                playerService.deletePlayer(item.id).then(() => {
                    this.page = page
                    this.fetchFilteredPlayers()
                })
            },
            setFilters(filters) {
                this.filters = filters
                this.$store.dispatch('setPlayerFilters', this.filters)
            },
            fetchFilteredPlayers() {
                this.loading = true
                playerService.getFilteredPlayers(this.filters, this.page, this.size, this.sortingOptions).then(resp => {
                    this.players = resp.data.content
                    this.totalPages = resp.data.totalPages
                    this.loading = false
                })
            },
            resetDoctorChecks() {
                playerService.resetDoctorChecks().then(() => {
                })
            }
        }
    }
</script>

<style scoped>
.card-title {
    display: flex;
}

.v-list-item {
    min-height: 30px !important;
}

.v-card {
    min-width: 250px;
    position: relative;
}

.header-card {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1%;
}

.header-buttons {
    align-self: center;
}

.edit-button:hover {
    background-color: whitesmoke;
    color: white;
}

.screen-card {
    padding: 4%;
}

.overflow-text {
    max-width: 79%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.pagination {
    justify-content: center;
}
</style>
